export default "__VITE_ASSET__kwyh$zC$__"